/**
 * Utility functions for constructing frontend and backend URLs from environment variables
 */
import { normalizeUrl } from '@sm-dashboard/formatting';

function resolveBackendUrl(): string {
  let normalizedUrl = normalizeUrl(
    (import.meta as { env?: { VITE_BASE_URL_API?: string } }).env?.VITE_BASE_URL_API,
    'https://api.chabadisrael.co.il/api/'
  );
  if (!normalizedUrl.endsWith('/')) {
    normalizedUrl += '/';
  }
  if (!normalizedUrl.endsWith('/api/')) {
    normalizedUrl += 'api/';
  }
  return normalizedUrl;
}

/**
 * Single source for app base URLs (frontend, backend, public sites). Use this from the rest of the backend.
 */
export function getUrls(): {
  frontendUrl: string;
  backendUrl: string;
  frontendExternalUrl: string;
  productionFrontendUrl: string;
  publicWebsiteUrl: string;
} {
  const env = (import.meta as { env?: Record<string, string | undefined> }).env || {};

  return {
    frontendUrl: normalizeUrl(env.VITE_FRONT_URL, 'https://int.chabadisrael.co.il'),
    backendUrl: resolveBackendUrl(),
    frontendExternalUrl: normalizeUrl(
      env.VITE_FRONTEND_EXTERNAL_URL || env.VITE_FRONT_EXTERNAL_URL,
      'https://pub.chabadisrael.co.il'
    ),
    productionFrontendUrl: normalizeUrl(env.VITE_PROD_FRONT_URL, 'https://int.chabadisrael.co.il'),
    publicWebsiteUrl: normalizeUrl('https://chabadisrael.co.il')
  };
}
